module.exports = __webpack_public_path__ + "img/logo-white.18fef19e.png";